import Wrapper from '@/components/base/Wrapper';
import MenuList from '@/components/menu/Menu';
import ClassSection from '@/components/menu/ClassSection';

const attendance = {
  path: 'attendance',
  component: Wrapper,
  meta: { breadCrumb: 'content.attendance_list' },
  children: [
    {
      path: '',
      name: 'AdvisorAttendanceIndex',
      component: () => import(/* webpackChunkName: "teacher-attendance-index" */ '@/pages/attendance-creator/index'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default' }
    },
    {
      path: 'view/:id',
      name: 'AdvisorAttendanceListView',
      component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { editable: false, type: 'school-advisor' }
    }
  ]
};

const assignment = {
  path: 'assignment',
  component: Wrapper,
  meta: { breadCrumb: 'menu.assignment_list' },
  children: [
    {
      path: '',
      name: 'AdvisorAssignment',
      component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/index'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default' },
      props: { type: 'school-advisor' }
    },
    {
      path: ':assignmentId/detail',
      component: Wrapper,
      meta: { breadCrumb: 'content.assignment_detail' },
      children: [
        {
          path: '',
          name: 'AdvisorAssignmentDetail',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/detail'),
          meta: { rule: 'isSchoolAdvisor', layout: 'default' },
          props: { type: 'school-advisor' }
        }
      ]
    }
  ]
};

const attendance_section = {
  path: 'attendance',
  component: Wrapper,
  meta: { breadCrumb: 'content.attendance_list' },
  children: [
    {
      path: '',
      name: 'AdvisorSectionAttendanceIndex',
      component: () => import(/* webpackChunkName: "teacher-attendance-index" */ '@/pages/attendance-creator/index'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default' }
    },
    {
      path: 'view/:id',
      name: 'AdvisorSectionAttendanceListView',
      component: () => import(/* webpackChunkName: "teacher-attendance" */ '@/pages/attendance-creator/CreateEdit'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default', breadCrumb: 'content.attendance_form' },
      props: { editable: false, type: 'school-advisor' }
    }
  ]
};

const syllabus = {
  path: 'syllabus',
  component: Wrapper,
  meta: { breadCrumb: 'content.syllabus' },
  children: [
    {
      path: '',
      name: 'SyllabusnAdvisorIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus/StudentView'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default' },
      props: { isClass: true, isStudent: true }
    }
  ]
};

const syllabus_section = {
  path: 'syllabus',
  component: Wrapper,
  meta: { breadCrumb: 'content.syllabus' },
  children: [
    {
      path: '',
      name: 'SyllabusnAdvisorIndexClassSection',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus/StudentView'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default' },
      props: { isClass: true, isStudent: true }
    }
  ]
};

const assignment_section = {
  path: 'assignment',
  component: Wrapper,
  meta: { breadCrumb: 'menu.assignment_list' },
  children: [
    {
      path: '',
      name: 'AdvisorSectionAssignment',
      component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/index'),
      meta: { rule: 'isSchoolAdvisor', layout: 'default' },
      props: { type: 'school-advisor' }
    },
    {
      path: ':assignmentId/detail',
      component: Wrapper,
      meta: { breadCrumb: 'content.assignment_detail' },
      children: [
        {
          path: '',
          name: 'AdvisorSectionAssignmentDetail',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment-creator/detail'),
          meta: { rule: 'isSchoolAdvisor', layout: 'default' },
          props: { type: 'school-advisor' }
        }
      ]
    }
  ]
};

export default [
  // SchoolAdvisor :: Class
  {
    path: '/advisor-class',
    component: Wrapper,
    meta: { breadCrumb: 'content.class_list' },
    children: [
      {
        path: '',
        name: 'AdvisorClassIndex',
        component: () => import(/* webpackChunkName: "school-class-index" */ '@/pages/class'),
        meta: { rule: 'isSchoolAdvisor', layout: 'default' },
        props: { type: 'school-advisor' }
      },
      {
        path: 'class/:classId',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_title' },
        children: [
          {
            path: '',
            name: 'AdvisorCourseList',
            component: () => import(/* webpackChunkName: "teacher-course" */ '@/components/menu/Course'),
            meta: { rule: 'isSchoolAdvisor', layout: 'default' },
            props: { type: 'school-advisor' }
          },
          {
            path: 'erapor',
            component: Wrapper,
            meta: { breadCrumb: 'content.erapor' },
            children: [
              {
                path: '',
                name: 'EraporAdvisorView',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/ListStudent'),
                meta: { rule: 'isSchoolAdvisor', layout: 'default' },
                props: { type: 'school-advisor' }
              },
              {
                path: 'view/:studentId',
                name: 'eRaporGeneratorViewStudentAdvisorClass',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isSchoolAdvisor', layout: 'default', breadCrumb: 'content.template_generate_view' },
                props: { type: 'school-advisor', isEditable: false }
              }
            ]
          },
          {
            path: 'course/:courseId',
            component: Wrapper,
            meta: { breadCrumb: 'table.menu' },
            children: [
              {
                path: '',
                name: 'AdvisorMenuList',
                component: MenuList,
                meta: { rule: 'isSchoolAdvisor', layout: 'default' },
                props: { type: 'school-advisor' }
              },
              assignment,
              attendance,
              syllabus
            ]
          },
          /* section class */
          {
            path: 'course/:courseId/sectionclass',
            component: Wrapper,
            meta: { breadCrumb: 'content.class_section' },
            children: [
              {
                path: '',
                name: 'AdvisorClassSectionList',
                component: ClassSection,
                meta: { rule: 'isSchoolAdvisor', layout: 'default' },
                props: { type: 'school-advisor' }
              },
              {
                path: ':classSectionId',
                component: Wrapper,
                meta: { breadCrumb: 'table.menu' },
                children: [
                  {
                    path: '',
                    name: 'AdvisorSectionMenuSectionList',
                    component: MenuList,
                    meta: { rule: 'isSchoolAdvisor', layout: 'default' },
                    props: { type: 'school-advisor' }
                  },
                  assignment_section,
                  attendance_section,
                  syllabus_section
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
